module.exports = __webpack_public_path__ + "static/media/built.0e279cd8.png";